"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./style.scss");
const TableBody = (props) => {
    const { className = '', noDataText = '無資料', children } = props;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `table__body ${children.length === 0 ? 'noData' : ''} ${className}` }, { children: [children.length === 0 && `${noDataText}`, children] })));
};
exports.default = TableBody;
